import FactureAvoirFactClientController from './facture.avoir.fact.client.controller';

export default {
    bindings: {
        modalInstance: '=',
        avoirResult: '=',
        date: '=',
        idClients: '='
    },
    template: require('./facture.avoir.fact.client.html'),
    controller: FactureAvoirFactClientController
};